import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BRANDS, setSelectedBrand } from '../utils/brand';

export default function BrandSelect() {
  const navigate = useNavigate();

  const choose = (brandKey) => {
    setSelectedBrand(brandKey);
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-2xl">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-primary-900">Booking Management System</h1>
          <p className="text-gray-500 mt-2">Which company are you managing today?</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {Object.values(BRANDS).map(brand => (
            <button key={brand.key} onClick={() => choose(brand.key)}
              className="group flex flex-col items-center gap-3 border-2 border-gray-200 rounded-xl p-8 hover:border-primary-600 hover:bg-primary-50 transition">
              <span className="text-5xl group-hover:scale-110 transition-transform">{brand.icon}</span>
              <span className="text-lg font-semibold text-gray-900">{brand.name}</span>
              <span className="text-xs text-gray-400">{brand.tagline}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
